import { useCallback, useEffect, useRef, useState } from 'react';
import { useConfig } from '../../contexts/config-context';
import { FORM_STATUS, useFormStatus } from '../../contexts/form-status-provider';
import { EMPTY_VALUE } from '../../constants';
import { convertToPNGFile, decodeDataUrl, isDataUrl } from './utils/data-url';
import { useUploadSignature } from './use-upload-signature';
export const useSignatureValue = _ref => {
  let {
    value,
    onChange,
    target
  } = _ref;
  const [signatureValue, setSignatureValue] = useState(value);
  const {
    isRTL: rtl
  } = useConfig();
  const uploadSignatureFile = useUploadSignature(target);
  const {
    setFormStatus
  } = useFormStatus();
  const uploadTimeoutIdRef = useRef();
  useEffect(() => {
    if (value === EMPTY_VALUE) {
      setSignatureValue(EMPTY_VALUE);
    }
  }, [value]);
  const cancelUpload = useCallback(() => {
    if (uploadTimeoutIdRef.current) {
      clearTimeout(uploadTimeoutIdRef.current);
      uploadTimeoutIdRef.current = null;
    }
  }, []);
  const signature = signatureValue == null ? void 0 : signatureValue[0];
  const decodedValue = signature != null && signature.url ? decodeDataUrl(signature.url) : undefined;
  const uploadSignature = useCallback(async _signature => {
    try {
      const dataUrl = (_signature == null ? void 0 : _signature.url) ?? '';
      if (isDataUrl(dataUrl)) {
        const signatureFile = await convertToPNGFile(dataUrl, rtl);
        if (signatureFile) {
          const uploadedValue = await uploadSignatureFile(signatureFile);
          onChange([uploadedValue]);
        } else {
          // The signature is empty ( example the user choose a fully transparent image )
          setSignatureValue(undefined);
          onChange(undefined);
        }
      }
      uploadTimeoutIdRef.current = null;
    } finally {
      setFormStatus(target, FORM_STATUS.READY);
    }
  }, [setFormStatus, target, rtl, uploadSignatureFile, onChange]);
  const handleChange = useCallback(newSignature => {
    const deferUploadSignature = _signature => {
      uploadTimeoutIdRef.current = setTimeout(() => uploadSignature(_signature), 1_500);
    };
    if (newSignature) {
      if (uploadTimeoutIdRef.current) {
        clearTimeout(uploadTimeoutIdRef.current);
        uploadTimeoutIdRef.current = null;
      }
      setSignatureValue([newSignature]);
      deferUploadSignature(newSignature);
    } else {
      onChange == null || onChange(null);
      setSignatureValue(undefined);
      setFormStatus(target, FORM_STATUS.READY);
    }
  }, [uploadSignature, onChange, setFormStatus, target]);
  return {
    handleChange,
    signature,
    decodedValue,
    cancelUpload
  };
};
//# sourceMappingURL=use-signature-value.js.map